import React from "react";
import { AccordionToggle } from "./styles";

export default ({ child, id }) => {
  return (
    <>
      <AccordionToggle eventKey={id}>{child}</AccordionToggle>
    </>
  );
};
